import { Tooltip, Link, Box, Chip } from "@mui/material";
import { round } from "lodash";
import dayjs from "dayjs";
import {
  ORDER_STATUS,
  getFileNameFromUrl,
  prettyNumericRound,
  getFormattedNumber,
} from "../../utils";
import NumericLabel from "../../components/NumericLabel";
import config from "../../config";

const getOrderPogColumns = () => [
  {
    field: "fl_dept_name",
    headerName: "Department",
    width: 160,
    sortable: false,
    renderCell: (params) => (
      <Tooltip title={params.value ?? ""}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_class_name",
    headerName: "Category",
    width: 160,
    sortable: false,
    renderCell: (params) => (
      <Tooltip title={params.value ?? ""}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_sub_name",
    headerName: "Planogram",
    width: 160,
    sortable: false,
    renderCell: (params) => (
      <Tooltip title={params.value ?? ""}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "region",
    headerName: "Region",
    width: 130,
    sortable: false,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value ? params.value : ""}>
          <span>{params.value ? params.value : "-"}</span>
        </Tooltip>
      );
    },
  },
  {
    field: "planogram",
    headerName: "Planogram #",
    width: 130,
    sortable: false,
    renderCell: (params) => (
      <Tooltip title={params.value ? getFileNameFromUrl(params.value) : ""}>
        <Link
          href={config.PogFileBasePath.concat(params.value)}
          target="_blank"
          rel="noreferrer noopener"
        >
          {getFileNameFromUrl(params.value)}
        </Link>
      </Tooltip>
    ),
  },
  {
    field: "PONumber",
    headerName: "PO Number",
    width: 120,
    sortable: false,
  },
  {
    field: "orderQty",
    headerName: "Order Qty.",
    width: 130,
    sortable: false,
    renderCell: (params) => (
      <NumericLabel isSeparator value={round(params.value || 0, 2)} />
    ),
  },
  {
    field: "totalCost",
    headerName: "Order Cost",
    width: 130,
    sortable: false,
    renderCell: (params) => {
      const value = prettyNumericRound(params.value || 0);
      return `$${getFormattedNumber(value)}`;
    },
  },
  {
    field: "ReleaseStatus",
    headerName: "Status",
    width: 150,
    sortable: false,
    renderCell: (params) => {
      let chipParams = {};
      if (!params.value) {
        return <></>;
      }
      if (params.value === ORDER_STATUS.notReleased) {
        chipParams = { label: params.value };
      } else {
        chipParams = { label: params.value, color: "success" };
      }
      return (
        <Box sx={{ mt: -0.1 }}>
          <Chip size="small" {...chipParams} />
        </Box>
      );
    },
  },
  {
    field: "ReleaseDateTime",
    headerName: "Release Date",
    width: 175,
    sortable: false,
    renderCell: (params) =>
      !!params.value ? (
        <Tooltip title={dayjs(params.value).format("MM/DD/YYYY")}>
          <span>{dayjs(params.value).format("MM/DD/YYYY")}</span>
        </Tooltip>
      ) : (
        ""
      ),
  },
];

export default getOrderPogColumns;
